import {FormControl, Textarea} from '@primer/react'
import {clsx} from 'clsx'
import type {ComponentProps} from 'react'

import styles from './PropertyDefinitionForm.module.css'

interface Props {
  value: string
  validationError?: string
  onChange: (value: string) => void
  inputRef?: ComponentProps<typeof Textarea>['ref']
  className?: string
}

export function DefinitionDescriptionField({value, validationError, onChange, inputRef, className}: Props) {
  return (
    <FormControl className={clsx(styles.propertyFormControl, className)}>
      <FormControl.Label>Description</FormControl.Label>
      <Textarea
        block
        rows={4}
        resize="vertical"
        placeholder="A short description about this property"
        ref={inputRef}
        value={value}
        onChange={e => onChange(e.target.value)}
      />

      {validationError && <FormControl.Validation variant="error">{validationError}</FormControl.Validation>}
    </FormControl>
  )
}
